import { createRowActions } from "@msuite/ui/table";
import { columns as baseColumns } from "@/sites/measurements/measurement/table-config";
import { RowActions } from "./row-actions";

export const columns = [...baseColumns, createRowActions(RowActions)];
